import { render, staticRenderFns } from "./ColorCard.vue?vue&type=template&id=2a6d0fe2"
import script from "./ColorCard.vue?vue&type=script&lang=js"
export * from "./ColorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports